import Component from "react-pure-render/component";
import React from "react";
import Isvg from "react-inlinesvg";
import moment from "moment";
import Griddle from "griddle-react";
import Tooltip from "rc-tooltip";

import { addNotificationsForInvalidFields } from "../lib/validationWeb";

class DateComponent extends Component {
  render() {
    return <span>{moment(this.props.data).format("DD.MM.YYYY")}</span>;
  }
}

class YesNoComponent extends Component {
  render() {
    return (
      <span>
        {this.props.data && "TAK"}
        {!this.props.data && "NIE"}
      </span>
    );
  }
}

class GroupsComponent extends Component {
  render() {
    let groups = "";

    if (!this.props.data) {
      return <div />;
    }

    for (let i = 0; i < this.props.data.length; i++) {
      groups += this.props.data[i].name;
      if (i != this.props.data.length - 1) {
        groups += ", ";
      }
    }

    return <span>{groups}</span>;
  }
}

class ActionComponent extends Component {
  render() {
    const {
      onDeleteUser,
      onEnableUser,
      onDisableUser,
      currentUser
    } = this.props.metadata.customComponentMetadata;
    const row = this.props.rowData;
    return (
      <div>
        {row.uid != currentUser && (
          <Tooltip
            placement="bottom"
            trigger={["click", "hover"]}
            overlay={
              <div className="popover">
                <a onTouchTap={onDeleteUser.bind(this, row.uid)}>usuń</a>
                <br />
                {row.active && (
                  <a onTouchTap={onDisableUser.bind(this, row, row.uid)}>
                    dezaktywuj
                  </a>
                )}
                {!row.active && (
                  <a onTouchTap={onEnableUser.bind(this, row, row.uid)}>
                    aktywuj
                  </a>
                )}
              </div>
            }
            getTooltipContainer={() => document.getElementById("wrapper")}
          >
            <div className="icon-table link" />
          </Tooltip>
        )}
      </div>
    );
  }
}

export default class Table extends Component {
  static propTypes = {
    actions: React.PropTypes.object.isRequired,
    users: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
  }

  onDeleteUser = (uid, e) => {
    e.preventDefault();

    const { actions } = this.props;
    actions.openRemoveUserModal(uid);
  };

  onDisableUser = (fields, uid, e) => {
    const { actions, notificationSystem } = this.props;
    actions.disableUser(fields, uid).then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      } else {
        let notification = {
          level: "success",
          message: "Użytkownik dezaktywowany!",
          position: "br",
          autoDismiss: 5,
          dismissible: true
        };
        notificationSystem.addNotification(notification);
        actions.getUsers().then(({ error, payload }) => {
          if (error) {
            addNotificationsForInvalidFields(payload, notificationSystem);
          }
        });
      }
    });
  };

  onEnableUser = (fields, uid, e) => {
    const { actions, notificationSystem } = this.props;
    actions.enableUser(fields, uid).then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      } else {
        let notification = {
          level: "success",
          message: "Użytkownik aktywowany!",
          position: "br",
          autoDismiss: 5,
          dismissible: true
        };
        notificationSystem.addNotification(notification);
        actions.getUsers().then(({ error, payload }) => {
          if (error) {
            addNotificationsForInvalidFields(payload, notificationSystem);
          }
        });
      }
    });
  };

  render() {
    const {
      users: { table, currentUser },
      config,
      actions,
      tableWidth,
      tableHeight
    } = this.props;

    // don't render table until we have currentUser, because columnMetadata changes doesn't re-render component
    if (!currentUser) {
      return <div />;
    }

    let columnMetadata = [
      {
        columnName: "email",
        displayName: "Email",
        cssClassName: "table-unsortable",
        visible: true
      },
      {
        columnName: "active",
        displayName: "Aktywny",
        cssClassName: "table-unsortable",
        visible: true,
        customComponent: YesNoComponent
      },
      {
        columnName: "is2FA",
        displayName: "Podwójna autentykacja",
        cssClassName: "table-unsortable",
        visible: true,
        customComponent: YesNoComponent
      },
      {
        columnName: "groups",
        displayName: "Grupy",
        cssClassName: "table-unsortable",
        visible: true,
        customComponent: GroupsComponent
      },
      {
        columnName: "createdAt",
        displayName: "Data dodania",
        cssClassName: "table-unsortable",
        visible: true,
        customComponent: DateComponent
      },
      {
        columnName: "actions",
        displayName: "Akcje",
        visible: true,
        cssClassName: "data-table-file table-unsortable",
        customComponent: ActionComponent,
        customComponentMetadata: {
          onDeleteUser: this.onDeleteUser,
          onEnableUser: this.onEnableUser,
          onDisableUser: this.onDisableUser,
          currentUser: currentUser && currentUser.uid
        }
      }
    ];

    return (
      <Griddle
        results={table.data}
        columnMetadata={columnMetadata}
        tableClassName="data-table"
        useGriddleStyles={false}
        columns={["email", "active", "is2FA", "groups", "createdAt", "actions"]}
        enableSort={false}
        enableInfiniteScroll={false}
        showPager={false}
        bodyHeight={tableHeight}
        resultsPerPage={100}
        noDataMessage={table.loading ? "" : "Brak danych"}
        sortAscendingComponent={
          <Isvg className="fa fa-sort-asc" src="/assets/img/icon_sort.svg" />
        }
        sortDescendingComponent={
          <Isvg className="fa fa-sort-desc" src="/assets/img/icon_sort.svg" />
        }
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/users/table.react.js